import ApiBase from './ApiBase';
import axios from 'axios';
import { stringify } from '../components/forked/stringify';

class EmailArchiveExcelDownloadApi extends ApiBase {
  /**
   * Get email archive details and recipients
   * as an excel file.
   * Filter by emailArchiveId (mandatory), firstName, lastName,
   * email address and email status.
   * @param filters
   * @param id
   * @param filters
   */
  async downloadEmailArchiveAsExcel(id, filters) {
    const queryParameters = stringify(
      {
        emailArchiveId: id,
        firstName: filters.firstName,
        lastName: filters.lastName,
        email: filters.email,
        emailStatus: filters.status
      },
      {
        arrayFormat: 'comma'
      }
    );
    const request = {
      url: `${this.API_URL}/emailarchive/emailrecipients/excel?${queryParameters}`,
      headers: this.getHeaders(),
      responseType: 'blob',
      method: 'GET'
    };
    const response = await axios.request(request);
    return response.data;
  }
}

export default new EmailArchiveExcelDownloadApi();
